
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.06 16.104c-3.441 2.739-8.434 2.547-11.58-.6C.091 12.117.127 6.592 3.556 3.163s8.954-3.465 12.341-.078c3.282 3.282 3.35 8.571.232 12.016l7.766 7.777-1.031 1.031zM4.365 14.618c2.904 2.904 7.641 2.873 10.58-.066s2.971-7.677.067-10.581-7.64-2.873-10.58.067-2.971 7.676-.067 10.58z"}})])
          )
        }
      }
    